<ng-container *ngFor="let item of dataToShow; let last = last">
  <div class="contenido" *ngIf="!last || (last && countDownResult() !== limitString)">
    <div class="digitos">
      <div class="contenedorDigito" *ngFor="let digit of countDownResult()[item.keyResult]?.split('')">
        {{ digit }}
      </div>
    </div>
    <div class="atextCenter">{{ item.literal | translate | uppercase }}</div>
  </div>
  <div *ngIf="!last" class="puntos">:</div>
</ng-container>
